import { useRef, useEffect } from "react"
import { Box } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"

import { CustomTab, LeftIcon, RightIcon, theme } from "./Atom"
import { useDispatch, useSelector } from "react-redux"
import {
  setExpandedD,
  setSelectedMetricOpportunityTab,
} from "../../../redux/slices/metricSlice"
import { setLoading } from "../../../redux/slices/appSlice"

type MetricOpportunityTabsProps = {
  fetchOpportunityByBucket: any
  // fetchAllMetricsAssignedToGroup: any
}

export default function MetricOpportunityTabs({
  fetchOpportunityByBucket,
}: // fetchAllMetricsAssignedToGroup,
MetricOpportunityTabsProps) {
  const tabsRef = useRef<any>(null)

  const dispatch = useDispatch()

  const loading = useSelector((state: any) => {
    return state.app.loading
  })
  const selectedMetricOpportunityTab = useSelector((state: any) => {
    return state.metric.selectedMetricOpportunityTab
  })

  const metricOpportunityTabs = useSelector((state: any) => {
    return state.metric.metricOpportunityTabs
  })

  const opportunityStatus = useSelector((state: any) => {
    return state.metric.opportunityStatus
  })

  const handleChange = async (tab: any, newValue: number) => {
    dispatch(setExpandedD({}))
    dispatch(
      setSelectedMetricOpportunityTab({
        ...metricOpportunityTabs[0],
        index: 0,
      }),
    )

    fetchOpportunityByBucket(tab?.metric_bucket_id || "all", newValue)
  }

  useEffect(() => {
    if (selectedMetricOpportunityTab) {
      dispatch(setLoading(true))

      if (selectedMetricOpportunityTab?.metric_bucket === "All") {
        fetchOpportunityByBucket(
          selectedMetricOpportunityTab?.metric_bucket_id,
          selectedMetricOpportunityTab?.index,
        ).then((res: any) => {
          console.log("res", res)

          dispatch(
            setSelectedMetricOpportunityTab({
              metric_bucket_id: "all",
              metric_bucket: "All",
              metrics: res?.metrics,
              columnHeaders: res?.columnHeaders,
              index: 0,
            }),
          )
        })

        dispatch(setLoading(false))
        return
      }

      fetchOpportunityByBucket(
        selectedMetricOpportunityTab?.metric_bucket_id,
        selectedMetricOpportunityTab?.index,
      )

      dispatch(setLoading(false))
    }
  }, [opportunityStatus])

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: 320, sm: 480, xl: "100%", md: "100%" },
          bgcolor: "#3C77EF",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
        }}
      >
        <Tabs
          ref={tabsRef}
          scrollButtons="auto"
          ScrollButtonComponent={(props) => {
            if (props.direction === "left") {
              return (
                <IconButton
                  size="small"
                  style={{ right: 36 }}
                  {...props}
                  disableRipple={true}
                >
                  <LeftIcon disabled={props.disabled} />
                </IconButton>
              )
            } else if (props.direction === "right") {
              return (
                <IconButton
                  size="small"
                  style={{ right: 0 }}
                  {...props}
                  disableRipple={true}
                >
                  <RightIcon disabled={props.disabled} />
                </IconButton>
              )
            } else {
              return null
            }
          }}
          value={selectedMetricOpportunityTab?.index || 0}
          // onChange={handleChange}
          variant="scrollable"
          aria-label="visible arrows tabs example"
          sx={{
            color: "primary.main",
            position: "relative",
            height: 56,
            paddingRight: 13,
            [`& .${tabsClasses.scrollButtons}`]: {
              position: "absolute",
              "&.Mui-disabled": { opacity: 0.9 },
            },
          }}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
        >
          {metricOpportunityTabs?.map((tab: any, index: any) => (
            <CustomTab
              key={tab?.metric_bucket_id}
              label={tab?.metric_bucket}
              onClick={(event: any) => handleChange(tab, index)}
              disabled={loading}
              style={{
                backgroundColor:
                  selectedMetricOpportunityTab?.index === index
                    ? "#ffffff"
                    : "#1c56ce",
                color:
                  selectedMetricOpportunityTab?.index === index
                    ? "black"
                    : "white",
                marginLeft: index === 0 ? "8px" : "0",
                fontSize:
                  selectedMetricOpportunityTab?.index === index
                    ? "16px"
                    : "16px",
                fontWeight:
                  selectedMetricOpportunityTab?.index === index ? "600" : "400",
                width: "fit-content",
                textTransform: "capitalize",
              }}
            />
          ))}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
}
